import { registerPlugin } from '@capacitor/core';

import type { ClogiUploaderPlugin } from './definitions';

const ClogiUploader = registerPlugin<ClogiUploaderPlugin>('ClogiUploader', {
  web: () => import('./web').then((m) => new m.ClogiUploaderWeb()),
});

export * from './definitions';
export { ClogiUploader };
